import { gql } from '@apollo/client';

export const DELETE_WORKSPACE_FORM = gql`
  mutation deleteWorkspaceForm($id: ID!) {
    workspaceForm: deleteWorkspaceForm(id: $id) {
      id
    }
  }
`;
